/**
 * Implementation of the Dark mode
 *
 * @link https://web.dev/prefers-color-scheme/ - more usages of dark mode
 * @link https://dark-mode-baseline.glitch.me/ - source
 *
 * Related to
 * - remove icon in Appearance > Customize > Site identity > Site Icon
 * - /resources/views/partials/head.blade.php
 * - /resources/assets/images/favicons
 */

// check if a browser supports the prefers-color-scheme
const isDarkModeSupported = window.matchMedia('(prefers-color-scheme)').media !== 'not all';

/**
 * update favicon
 *
 * @param {array} favicons - a list of nodes with rel="icon" attribute, in case there are multiple by accident
 * @param {boolean} darkModeOn - is the Dark mode enabled
 */
function updateFavicon(favicons, darkModeOn) {
    favicons.forEach((link) => {
        link.href = darkModeOn ? link.dataset.hrefDark : link.dataset.hrefLight;
    });
}

if (false !== isDarkModeSupported) {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)'),
        favicons = document.querySelectorAll('link[rel="icon"]');

    let darkModeOn = darkModeMediaQuery.matches;

    // update favicon
    updateFavicon(favicons, darkModeOn);

    // monitor if the Dark mode changes (turned on or off)
    darkModeMediaQuery.addListener((e) => {
        // update the Dark mode status
        darkModeOn = e.matches;

        // update favicon
        updateFavicon(favicons, darkModeOn);
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/other/dark-mode.js